import styled from 'styled-components'

export const IncognitoContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    ${props => !props.isMobile && 
    `background-image: url(${props.img});
    background-size: ${window.innerWidth / window.innerHeight > 3 ? window.innerHeight - 20 + 'px' : '31%'};
    background-position: left top;
    background-repeat: no-repeat;`
    }
    &:after {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: ${props => props.isMobile ? 'none' : 'block' } ;
        content: '';
        background-color: rgba(255,255,255,.5) ;
    }
    
`

export const IncognitoTextContainer = styled.div`
    max-width: 670px;
    min-height: 115px;
    position: relative;
    z-index: 1;
    
    ${props => props.isMobile && 
    `padding: 115px 15px 15px;
    background-image: url(${props.img});
    background-size: 95px;
    background-position: center 10px;
    background-repeat: no-repeat;
    margin-bottom: 30px;
    `
    };
    @media screen and (max-width: 980px) and (max-height: 150px) {
        ${props => props.isMobile ? 'margin-bottom: 0px;' : '' } 
    }
    @media screen and (max-width: 411px) and (max-height: 225px) and (min-height: 150px) {
        ${props => !props.isMobile ? 'margin-bottom: 40px;' : '' } 
    }
`
export const IncognitoTextHeader = styled.div`
    font-weight: 500;
    font-size: ${props => props.isMobile ? '28px' : '30px' };
    line-height: 1;
    text-align: ${props => props.isMobile ? 'left' : 'center' };
    padding: ${props => props.isMobile ? '0px 10px 0px 3px' : '0px 20px' };
    text-transform: uppercase;
    color: #F77268;
`

export const IncognitoTextDescription = styled.div`
    font-weight: normal;
    font-size: ${props => props.isMobile ? '14px' : '18px' };
    line-height: 1.4;
    text-align: left;
    color: #162D3D;
    padding: ${props => props.isMobile ? '0' : '10px 20px' } ;
    padding-top: ${props => props.isMobile ? '16px' : '20px' } ;
    span {
        font-weight: ${props => props.isMobile ? 'bold' : 'inherit' };
    }

    img {
        display: ${props => props.isMobile ? 'inline-block' : 'none' };
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 9px;
        transform: translateY(16%);
    }
`
export const IncognitoIconSpan = styled.span`
    background-color: #E0E0E0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    svg {
        transform: translate(2%, -2%);
    }
`
export const IncognitoAppName = styled.div`
    display: ${props => props.isMobile ? 'none' : 'flex' };
    position: absolute;
    bottom: ${props => props.isMobile ? '19px' : '30px' };
    right: ${props => props.isMobile ? '20px' : '40px' };
    ${props => props.isMobile ? 'left: 20px;' : '' }
    justify-content: ${props => props.isMobile ? 'center' : 'flex-end' };
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: rgba(22, 45, 61, 0.5);
    z-index: 1;

    img {
        width: ${props => props.isMobile ? '20px' : '30px' };
        height: ${props => props.isMobile ? '20px' : '30px' };
        display: block;
        border-radius: 50%;
        margin-right: 9px;
        margin-left: 9px;
    }
    @media screen and (max-width: 980px) and (max-height: 250px) {
        display: none;
    }
    @media screen and (max-width: 980px) and (max-height: 300px) and (min-height: 250px) {
        ${props => !props.isMobile ? 'bottom: 10px; display: flex;' : '' } 
    }
`